export { default as promoBanner } from './banner.png';
export { default as promoFondo } from './fondo.png';
export { default as logoSandos4u } from './logo-sandos4u.png';
export { default as iconPercent } from './icon-percent.png';
export { default as iconDollar } from './icon-dollar.png';
export { default as iconGift } from './icon-gift.png';
export { default as iconUser } from './icon-user.png';
export { default as iconFacebook } from './icon-facebook.png';
export { default as iconInstagram } from './icon-instagram.png';
export { default as iconYoutube } from './icon-youtube.png';
export { default as iconChevron } from './icon-chevron.png';
